import { DollarCircleOutlined, HomeOutlined, PlusOutlined, RiseOutlined } from '@ant-design/icons'
import { Card, Col, Row, Spin } from 'antd'
import { ReactNode } from 'react'

import { useBoosterProgramStats } from 'hooks/booster-program'

interface OverviewCardData {
  title: string
  value: number
  icon: ReactNode
  iconBg: string
  iconColor: string
}

export const BoosterProgramOverviewCards = () => {
  const { stats, isLoading } = useBoosterProgramStats()

  const cards: OverviewCardData[] = [
    {
      title: 'Total Programs',
      value: stats.totalPrograms,
      icon: <HomeOutlined />,
      iconBg: '#dbeafe',
      iconColor: '#155dfc',
    },
    {
      title: 'Total Enrolled Users',
      value: stats.totalEnrolledUsers,
      icon: <RiseOutlined />,
      iconBg: '#ffe2e2',
      iconColor: '#e7000b',
    },
    {
      title: 'Total Codes Issued',
      value: stats.totalCodesIssued,
      icon: <DollarCircleOutlined />,
      iconBg: '#dcfce7',
      iconColor: '#00a63e',
    },
    {
      title: 'Total Codes Applied',
      value: stats.totalCodesApplied,
      icon: <PlusOutlined />,
      iconBg: '#ffedd4',
      iconColor: '#f54900',
    },
  ]

  return (
    <div className="booster-program-overview">
      <div className="booster-program-overview__title">Booster Program Overview</div>
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col key={card.title} xs={24} sm={12} lg={6}>
            <Card className="booster-program-overview__card">
              <div className="booster-program-overview__card-content">
                <div className="booster-program-overview__card-text">
                  <div className="booster-program-overview__card-label">{card.title}</div>
                  <div className="booster-program-overview__card-value">
                    {isLoading ? (
                      <Spin size="small" />
                    ) : (
                      new Intl.NumberFormat('en-US').format(card.value)
                    )}
                  </div>
                </div>
                <div
                  className="booster-program-overview__card-icon"
                  style={{ backgroundColor: card.iconBg, color: card.iconColor }}
                >
                  {card.icon}
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}
